export const environment = {
  production: true,
  version: "0.0.1",
  basePozzwareUrl: "https://pozzware.com/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts